import React, { useEffect, useState } from 'react';

import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';
import moment from 'moment';
import { Button, Modal } from 'react-bootstrap';
import { useForm } from 'react-hook-form';

import whiteLogoSafety from '../../images/logoBranco.png';
import Chart from '../Charts/GoogleChartsCompat';

import {
  getGroupSystemMaintenanceOpen,
  getQuantTratativasOp,
  getSupervisaoMaintenance,
  listOperators,
} from '../Api/Api';

export default function SupervisionModal({
  show,
  handleClose,
  initialInfo = {},
  optionsPie = {},
  initialDataPie = [['Operador', 'Quantidade de tratativas']],
  dataPieNCsGeneral = {},
}) {
  const { register, handleSubmit } = useForm();
  const [info, setInfo] = useState({});
  const [dataPie, setDataPie] = useState([]);
  const [operators, setOperators] = useState([]);
  const [dataPieNCs, setDataPieNCs] = useState({});

  const optionsPieNCs = {
    title: 'Itens de segurança / Não Conformes (sem recorrência e intervalo)',
    sliceVisibilityThreshold: 0,
  };

  const isObjectEmpty = (obj) => Object.keys(obj).length === 0;

  const exportPDF = () => {
    const input = document.getElementById('modalSupervision');

    html2canvas(input, { scale: 1 }).then((canvas) => {
      const imgData = canvas.toDataURL('image/png');

      const imgWidth = canvas.width * 0.264583;
      const imgHeight = canvas.height * 0.264583;

      const pdf = new jsPDF({
        orientation: imgWidth > imgHeight ? 'landscape' : 'portrait',
        unit: 'mm',
        format: [imgWidth, imgHeight],
      });

      pdf.addImage(imgData, 'PNG', 0, 0, imgWidth, imgHeight);

      const logoImg = new Image();
      logoImg.src = whiteLogoSafety;

      logoImg.onload = function () {
        const logoWidth = (logoImg.width * 0.264583) / 3;
        const logoHeight = (logoImg.height * 0.264583) / 3;

        const overlayXPosition = 5;
        const overlayYPosition = 4;

        pdf.addImage(
          logoImg,
          'PNG',
          overlayXPosition,
          overlayYPosition,
          logoWidth,
          logoHeight
        );

        pdf.save(`Painel de Supervisão - Relatório gerencial.pdf`);
      };

      logoImg.onerror = function () {
        console.error('Erro ao carregar a imagem.');
      };
    });
  };

  const filter = async (data) => {
    let postData = {
      dt_ini: data.dt_init,
      dt_fim: data.dt_end,
      user_id: data.operator_user_id,
    };

    const res = await getSupervisaoMaintenance(postData);
    if (res.data) {
      setInfo(res.data);
    }

    const res1 = await getQuantTratativasOp(postData);
    if (res1.data) {
      const newDataPie = res1.data.map((element) => [
        element.operator_name,
        Number(element.treatment_count),
      ]);
      setDataPie([['Operador', 'Quantidade de tratativas'], ...newDataPie]);
    }

    const res2 = await getGroupSystemMaintenanceOpen(
      null,
      null,
      null,
      postData.user_id
    );
    if (res2 && res2.data && Array.isArray(res2.data)) {
      const newDataPie = res2.data.map((item) => [
        item.system_type_name + ' (' + parseInt(item.count) + ')',
        parseInt(item.count),
      ]);
      newDataPie.unshift(['Item', 'Qtd NCs abertas por Item de segurança']);
      setDataPieNCs(newDataPie);
    }
  };

  const getDisplayValue = (key) => {
    return !isObjectEmpty(info) ? info[key] : initialInfo[key];
  };

  const getDisplayValueChart = () => {
    return !isObjectEmpty(dataPie) ? dataPie : initialDataPie;
  };

  const listOperatorss = async () => {
    const res = await listOperators();
    setOperators(res.data);
  };

  useEffect(() => {
    if (show) {
      listOperatorss();
      setDataPieNCs(dataPieNCsGeneral);
    }
  }, [show]);

  return (
    <Modal show={show} size="xl" onHide={handleClose}>
      <div id="modalSupervision">
        <Modal.Header className="text-center bg-red-default" closeButton>
          <Modal.Title className="w-100">
            <span>Painel de Supervisão - Relatório gerencial</span>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="p-4">
          <form onSubmit={handleSubmit(filter)}>
            <div className="row">
              <div className="col-md-3 col-sm-12">
                <label>
                  Data início <span className="text-danger">*</span>
                </label>
                <input
                  type="date"
                  max={moment().startOf('day').format('YYYY-MM-DD')}
                  className="form-control"
                  {...register('dt_init')}
                  required
                />
              </div>
              <div className="col-md-3 col-sm-12">
                <label>
                  Data fim <span className="text-danger">*</span>
                </label>
                <input
                  type="date"
                  className="form-control"
                  {...register('dt_end')}
                  required
                />
              </div>
              <div className="col-md-4 col-sm-12">
                <label>Operador</label>
                <select
                  className="form-select"
                  id="operator"
                  aria-label="Operador"
                  {...register('operator_user_id')}
                >
                  <option value="">Selecione</option>
                  {operators.length > 0 &&
                    operators.map((item, index) => {
                      return (
                        <option key={index} value={item.user_id}>
                          {item.user_name}
                        </option>
                      );
                    })}
                </select>
              </div>
              <div className="col-md-2 col-sm-12 align-self-end">
                <button
                  className="btn py-1 btn-secondary btnFilter w-100"
                  type="submit"
                >
                  Filtrar
                </button>
              </div>
            </div>
          </form>
          <hr className="my-4" />
          <div className="row d-flex justify-content-around">
            <div className="col-sm-12 col-md-3 col-lg-3">
              <div className="card noShadow">
                <div className="card-body bg-NCs-day space">
                  <div className="card-title text-center">
                    <i className="bi bi-calendar-week-fill icon-supervision"></i>
                    <h2 className="mt-4">
                      <b>{getDisplayValue('tratadas_todas')}</b>
                    </h2>
                    <h5>
                      <b>Tratativas</b>
                    </h5>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-sm-12 col-md-3 col-lg-3">
              <div className="card noShadow">
                <div className="card-body bg-NCs-day space">
                  <div className="card-title text-center">
                    <i className="bi bi-calendar-range-fill icon-supervision"></i>
                    <h2 className="mt-4">
                      <b>{getDisplayValue('tratadas')}</b>
                    </h2>
                    <h5>
                      <b>NCs tratadas</b>
                    </h5>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-sm-12 col-md-3 col-lg-3">
              <div className="card noShadow">
                <div className="card-body bg-NCs-day space">
                  <div className="card-title text-center">
                    <i className="bi bi-calendar2-check-fill icon-supervision"></i>
                    <h2 className="mt-4">
                      <b>{getDisplayValue('encerradas')}</b>
                    </h2>
                    <h5>
                      <b>NCs encerradas</b>
                    </h5>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="row mb-5">
            <div className="col-sm-12 col-md-8 offset-md-2 scrollAxis">
              <div className="chartMobile">
                <Chart
                  chartType="PieChart"
                  data={getDisplayValueChart()}
                  options={{
                    ...optionsPie,
                    legend: { position: 'labeled' },
                  }}
                  width={'100%'}
                  height={'400px'}
                />
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-sm-12 col-md-8 offset-md-2 scrollAxis">
              <Chart
                chartType="PieChart"
                data={dataPieNCs}
                options={optionsPieNCs}
                width={'100%'}
                height={'400px'}
              />
            </div>
          </div>
        </Modal.Body>
      </div>
      <Modal.Footer>
        <Button variant="btn btn-success" onClick={exportPDF}>
          Exportar para PDF
        </Button>
      </Modal.Footer>
    </Modal>
  );
}
